import { NgbDateStruct, NgbTimeStruct } from "@ng-bootstrap/ng-bootstrap";
import { TenantsModel } from ".";
import { GuardModel } from "./guard-model";
import { IncidentModel } from "./incident-model";
import { ReportTypeModel } from "./report-type-model";
import { ReportImageModel } from "./reportImageModel";
import { RyckrapportDataModel } from "./ryckrapportDataModel";

export class ReportModel {
    public Id: number;
    public ReportTypeId: number;
    public ReportType: ReportTypeModel;
    public TenantId: number;
    public Tenant: TenantsModel;
    public nbDate: NgbDateStruct;
    public nbTime: NgbTimeStruct;
    public Date: Date;
    public Time: Date;
    public Cause: string;
    public GuardId: number;
    public Guard: GuardModel;
    public AdditionalText: string;
    public PoliceReport: boolean;
    public Resolution: string
    public PoliceAuthority: string
    public Plaintiff: string
    public Address: string
    public Phone: string
    public Location: string
    public IncidentText: string
    public IncidentId: number;
    public Incident: IncidentModel;
    public By: string;
    public nbTimeClosedFrom: NgbTimeStruct;
    public nbTimeClosedTo: NgbTimeStruct;
    public RyckrapportDatas: RyckrapportDataModel[];
    public ReportImages: ReportImageModel[];
    public OrderNumber: string;

    public alarmTime: NgbTimeStruct;
    public guardTime: NgbTimeStruct;
    public actionTime: NgbTimeStruct;

    public VisibleEffect: boolean;
    public AlarmReset: boolean;
    public PoliceCalled: boolean;
    public KManInformed: boolean;
    public KManUnavailable: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/report-model.ts